export default "__VITE_ASSET__DdxYjobU__"